import { Box, CardMedia, SxProps } from '@mui/material';

import { CompanyLogoData } from '~/data/company';
import { mergeSxProps } from '~/utils/helpers/sxProps';

import { useSxStyles } from './useStyles';

type Props = {
  companyLogoData?: CompanyLogoData;
  sx?: SxProps;
};

export const CompanyLogo = (props: Props) => {
  const { companyLogoData, sx } = props;
  const sxStyles = useSxStyles();

  if (!companyLogoData) {
    return null;
  }

  if (!companyLogoData.fComUseLogo) {
    return (
      <Box sx={mergeSxProps(sxStyles.companyLogoText, sx)}>
        {companyLogoData?.fComLogoAltText}
      </Box>
    );
  }

  return (
    <CardMedia
      component="img"
      sx={mergeSxProps(sxStyles.companyLogoImg, sx)}
      src={`/d/bin/company/logo/${companyLogoData?.fComLogoId}`}
      alt={companyLogoData?.fComLogoAltText}
    />
  );
};
